import { restClient } from '@/Core'

import { toCollection, toNode } from '../Helpers/diskResponse'

import type { DiskCollection, DiskNode } from '../Contracts/DiskNode'

/** Кошик простору — лише корені операцій «у кошик»: `GET /services/disk/trash?storage=`. */
export const LoadDiskTrashTask = async (storageUuid: string): Promise<DiskCollection<DiskNode>> => {
    const response = (await restClient.get(
        '/services/disk/trash',
        { searchParams: { storage: storageUuid, limit: '300' } },
        { forceRefresh: true }
    )) as unknown

    return toCollection(response, toNode)
}
